import * as React from 'react';
import { View, StyleSheet, Button, Dimensions } from 'react-native';
import { Video, ResizeMode } from 'expo-av';
import * as RootNavigation from '../../../../root.navigation.js';

const width = Dimensions.get('window').width;
const height = Dimensions.get('window').height;

export const V2200Screen = () => {
  const video = React.useRef(null);
  const [status, setStatus] = React.useState({});
  React.useEffect(()=>{
    video.current.playAsync()
  },[])
  return (
    <View style={styles.container}>
    <Button style={styles.buttons} onPress={()=>{RootNavigation.navigate('ipevo')}}>
      بازگشت
    </Button>
      <Video
        ref={video}
        style={styles.video}
        // source={require('../../../../assets/video/DoCam.mp4')}
        source={{
          uri: 'http://fntpf.ir/ziker/img/2200.mp4'
        }}
        // useNativeControls
        resizeMode={ResizeMode.CONTAIN}
        isLooping
        onPlaybackStatusUpdate={status => setStatus(() => status)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    backgroundColor: '#000',
    width,
    height
  },
  video: {
    alignSelf: 'center',
    width: width,
    height: height
  },
  buttons: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
